<template>
    <div>
        <label class="label-autocomplete">
            <gmap-autocomplete
                    @place_changed="setPlace" style="width:500px;" id="autoCom">
            </gmap-autocomplete>
            <button @click="addMarker" class="btn btn-info btn-sm ml-2" :hidden="complete">Adicionar</button>
<!--            <button @click="editarEnder" class="btn btn-info text-white btn-sm ml-2" :hidden="!complete"-->
<!--                    title="Clique aqui para editar o endereço">Editar-->
<!--            </button>-->
            <button @click="editarMarker" class="btn btn-warning text-white btn-sm ml-2" :hidden="!complete">Limpar
            </button>
        </label>
        <GmapMap
                :options="{
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            disableDefaultUi: true,
            gestureHandling: 'greedy'
            }"
                :center="center"
                :zoom="16"
                style="width: 100%; height: 300px"
        >

            <GmapMarker
                    :position="center"
                    :clickable="true"
                    :draggable="true"
                    @dragend="updateCoordinates"
            />
        </GmapMap>
        <form class="myForm mt-5">
                <div class="form-group row">
                    <label for="nome" class="col-sm-2 col-form-label">Cep: </label>
                    <div class="col-sm-4">
                        <the-mask class="form-control" :mask="'#####-###'" v-model="cep"                                  @input="inicializaMapa"/>
                    </div>
                    <label for="nome" class="col-sm-2 col-form-label">Endereço: </label>
                    <div class="col-sm-4">
                        <input type="text" class="form-control" v-model="endereco"
                               @change="inicializaMapa">
                    </div>
                </div>
                <div class="form-group row">
                    <label for="nome" class="col-sm-2 col-form-label">Nro: </label>
                    <div class="col-sm-1">
                        <input class="form-control" type="text" v-model="endNumero" @change="inicializaMapa">
                    </div>
                    <label for="nome" class="col-sm-1 col-form-label">Ref.: </label>
                    <div class="col-sm-2">
                        <input type="text" class="form-control" v-model="referencia">
                    </div>
                    <label for="nome" class="col-sm-2 col-form-label">Bairro: </label>
                    <div class="col-sm-4">
                        <input type="text" class="form-control" v-model="bairro">
                    </div>
                </div>
                <div class="form-group row">
                    <label for="nome" class="col-sm-2 col-form-label">Latitude: </label>
                    <div class="col-sm-4">
                        <input type="text" class="form-control" v-model="latitude" :disabled="true">
                    </div>
                    <label for="nome" class="col-sm-2 col-form-label">Longitude: </label>
                    <div class="col-sm-4">
                        <input type="text" v-model="longitude" class="form-control" :disabled="true">
                    </div>
                </div>
                <hr>

            <div class="form-group row">
                <label for="nome" class="col-sm-2 col-form-label">Número:<span class='text-danger'> *</span></label>
                <div class="col-sm-4">
                    <input type="text" class="form-control" v-model="numero">
                </div>
                <label for="nome" class="col-sm-2 col-form-label">Data Prevista:</label>
                <div class="col-sm-4">
                    <datepicker
                            v-model="dtPrevista"
                            :lang="lang"
                            format="DD/MM/YYYY"
                            @change="validaData('dtPrevista')"
                    ></datepicker>
                </div>
            </div>

            <div class="form-group row">
                <label for="nome" class="col-sm-2 col-form-label">Data de Início:</label>
                <div class="col-sm-4">
                    <datepicker
                            v-model="dtInicio"
                            :lang="lang"
                            format="DD/MM/YYYY"
                            @change="validaData('dtInicio')"
                    ></datepicker>
                </div>
                <label for="nome" class="col-sm-2 col-form-label">Data de Conclusão:</label>
                <div class="col-sm-4">
                    <datepicker
                            v-model="dtConcl"
                            :lang="lang"
                            format="DD/MM/YYYY"
                            @change="validaData('dtConcl')"
                    ></datepicker>
                </div>
            </div>
            <div class="form-group row">
                <label for="nome" class="col-sm-2 col-form-label">Objeto:</label>
                <div class="col-sm-4">
                    <textarea class="form-control" v-model="objeto" rows="3">
                    </textarea>
                </div>
                <label for="nome" class="col-sm-2 col-form-label">Descrição:<span class='text-danger'> *</span></label>
                <div class="col-sm-4">
                    <textarea class="form-control" v-model="descricao" rows="3">
                    </textarea>
                </div>
            </div>
            <div class="form-group row">
                <label for="nome" class="col-sm-2 col-form-label">Área:<span class='text-danger'> *</span></label>
                <div class="col-sm-4" required>

                    <div id="combo_area"></div>

                </div>
                <label for="nome" class="col-sm-2 col-form-label">Contrato:</label>
                <div class="col-sm-4">
                    <input type="text" class="form-control" v-model="contrato">
                </div>
            </div>
            <div class="form-group row">
                <label for="nome" class="col-sm-2 col-form-label">Convênio:<span class='text-danger'> *</span> </label>
                <div class="col-sm-4">

                    <div id="combo_convenios"></div>

                </div>
            </div>
            <div class="form-group row">
                <label for="nome" class="col-form-label unicCol">Órgão Fiscalizador: </label>
                <div class="col-sm-10">
                    <input type="text" class="form-control" v-model="orgaoFisc">
                </div>
            </div>
            <div class="form-group row">
                <label for="nome" class="col-form-label unicCol">Contratante: </label>
                <div class="col-sm-10">
                    <input type="text" class="form-control" v-model="contratante">
                </div>
            </div>
            <div class="form-group row">
                <label for="nome" class="col-form-label unicCol">Contratada: </label>
                <div class="col-sm-10">
                    <input type="text" class="form-control" v-model="contratada">
                </div>
            </div>
            <div class="form-group row">
                <label for="nome" class="col-sm-2 col-form-label">Valor (R$): </label>
                <div class="col-sm-4">
                    <money class="form-control" v-bind="money" v-model="valorObra"></money>
                </div>
                <label for="nome" class="col-sm-2 col-form-label">Número ART: </label>
                <div class="col-sm-4">
                    <input type="text" class="form-control" v-model="numeroArt">
                </div>
            </div>
            <div class="form-group row">
                <label for="nome" class="col-sm-2 col-form-label">Resp. Técnico: </label>
                <div class="col-sm-4">
                    <input type="text" class="form-control" v-model="respTecnico">
                </div>
                <label for="nome" class="col-sm-2 col-form-label">Tipo de Obra:<span class='text-danger'> *</span>
                </label>
                <div class="col-sm-4">

                    <div id="combo_tpobra"></div>

                </div>
            </div>
            <div class="form-group row">
                <label for="nome" class="col-sm-2 col-form-label">Tipo de Execução:<span class='text-danger'> *</span>
                </label>
                <div class="col-sm-4">

                    <div id="combo_execu"></div>

                </div>
                <label for="nome" class="col-sm-2 col-form-label">Situação / Status:<span class='text-danger'> *</span>
                </label>
                <div class="col-sm-4">

                    <div id="combo_situacoes"></div>

                </div>
            </div>

        </form>
        <div class="container text-right mt-2">
            <button class="btn btn-sm btn-danger" @click="retorno">Retornar</button>
            <button class="btn btn-sm btn-success ml-2"
                    :disabled="(!numero != '' || !descricao != '' || !tpAreaSel != '' || !tpConvSel != '' || !tpExecSel != '' || !tpObraSel != '' || !tpSituSel != '' || !latitude != '' || !longitude != '')"
                    @click="salvar">Salvar
            </button>
        </div>
    </div>

</template>

<script>
    import MenuInternoCadastros from '../menu-interno/MenuInternoCadastros.vue'
    import Datepicker from 'vue2-datepicker'

    var comboArea, comboTpObras, comboConv, comboExec, comboSituacoes, cidade = "Ibiúna";

    const axios = require('axios');

    export default {
        name: 'ObrasCadastro',
        props: {
            classe: String
        },
        data() {
            return {
                numero: '',
                cep: '',
                dtInicio: null,
                objeto: '',
                dtPrevista: null,
                descricao: '',
                dtConcl: null,
                areas: '',
                contrato: '',
                contratada: '',
                bairro: '',
                endereco: '',
                endNumero: '',
                referencia: '',
                latitude: '',
                longitude: '',
                valorObra: '',
                numeroArt: '',
                respTecnico: '',
                tpObras: '',
                tpExec: '',
                situacoes: '',
                convenios: '',
                orgaoFisc: '',
                contratante: '',
                tpObraSel: '',
                tpAreaSel: '',
                tpConvSel: '',
                tpExecSel: '',
                tpSituSel: '',
                preencheuEnd: false,
                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: 'R$ '
                },
                center: {lat: -23.6568599, lng: -47.2168921},
                markers: [],
                places: [],
                currentPlace: null,
                complete: false,
                completeDisa: false,
                lang: {
                    days: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
                    months: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
                    pickers: ['próximos 7 dias', 'próximos 30 dias', '7 dias atrás', '30 dias atrás'],
                    placeholder: {
                        date: 'Selecione uma Data',
                        dateRange: 'Selecione um range de Datas'
                    }
                }
            }
        },
        components: {
            Datepicker,
            MenuInternoCadastros
        },
        methods: {
            retorno() {
                this.$router.go(0)
            },
            formataData(dt){
                return new Date(dt).toLocaleDateString('ko-KR', {
                    year : 'numeric',
                    month : '2-digit',
                    day : '2-digit'
                }).split('. ').join('-').replace('.','');
            },
            validaData(dt) {
                if(this.dtInicio == null || this.dtConcl == null)
                    return;

                let thisVue = this;
                let dtIni = this.formataData(this.dtInicio);
                let dtCon = this.formataData(this.dtConcl);

                if (dtIni > dtCon) {
                    this.$swal(
                        'Atenção!',
                        'A data de início deve ser menor que a data de conclusão',
                        'info'
                    ).then(function () {
                        thisVue[dt] = null;
                    });
                }
            },
            setPlace(place) {
                this.currentPlace = place
            },
            dadosEndereco(pos) {
                let that = this;
                var geocoder = new google.maps.Geocoder();
                geocoder.geocode({
                    latLng: {lat: pos.latLng.lat(), lng: pos.latLng.lng()}
                }, function (objResposta) {
                    var arrNomesEnd = {
                        route: 'rua',
                        sublocality_level_1: 'bairro',
                        administrative_area_level_2: 'cidade',
                        administrative_area_level_1: 'estado',
                        street_number: 'numero',
                        country: 'pais',
                        postal_code: 'cep'
                    };
                    var objEndereco = new Object();
                    var componentForm = {
                        street_number: 'long_name',
                        route: 'long_name',
                        sublocality_level_1: 'long_name',
                        country: 'long_name',
                        postal_code: 'long_name',
                        administrative_area_level_1: 'short_name',
                        administrative_area_level_2: 'long_name',
                    };


                    if (objResposta[0] && objResposta[0].address_components.length > 0) {
                        for (var i = 0; i < objResposta[0].address_components.length; i++) {
                            var tipos = objResposta[0].address_components[i].types;

                            for(var j = 0; j < tipos.length; j++) {
                                if (typeof arrNomesEnd[tipos[j]] != 'undefined') {
                                      objEndereco[arrNomesEnd[tipos[j]]] = objResposta[0].address_components[i][componentForm[tipos[j]]];
                                }
                            }
                        }
                    } else {
                        objEndereco = {rua: '', numero: '', bairro: '', cidade: '', uf: '', pais: '', cep: ''};
                    }
                    that.endereco = objEndereco.rua
                    that.bairro = objEndereco.bairro
                    that.cep = objEndereco.cep
                    that.endNumero = objEndereco.numero
                });
            },
            updateCoordinates(location) {
                this.latitude = location.latLng.lat();
                this.longitude = location.latLng.lng();

                this.dadosEndereco(location)
            },
            editarEnder() {
                document.getElementById('autoCom').value = '';
                this.completeDisa = false
            },
            editarMarker() {
                this.complete = false
                this.endereco = ''
                this.endNumero = ''
                this.cep = ''
                this.bairro = ''
                this.latitude = ''
                this.longitude = ''

                document.getElementById('autoCom').value = '';
                $('#autoCom').removeAttr('disabled');
            },
            addMarker() {
                if (this.currentPlace != null) {
                    this.latitude = this.currentPlace.geometry.location.lat()
                    this.longitude = this.currentPlace.geometry.location.lng()

                    this.dadosEndereco({latLng: this.currentPlace.geometry.location});

                    const marker = {
                        lat: this.currentPlace.geometry.location.lat(),
                        lng: this.currentPlace.geometry.location.lng()
                    };
                    this.markers.push({position: marker});
                    this.places.push(this.currentPlace);
                    this.center = marker;
                    this.complete = true;
                    this.completeDisa = true;

                    this.currentPlace = null

                    $('#autoCom').attr('disabled', 'disabled');
                }
            },
            inicializaMapa() {
                var dados = {
                    cep: this.cep,
                    logradouro: this.endereco,
                    numero: this.endNumero,
                    latitude: this.latitude,
                    longitude: this.longitude,
                }

                var endereco = null;
                if (dados.cep != null) {
                    endereco = dados.cep;
                }

                if (dados.logradouro != null) {
                    endereco += ' ' + dados.logradouro + ', ' + (dados.numero != null ? dados.numero : '');
                }

                if (cidade != null) {
                    endereco += ', ' + cidade;
                }
                var addressObj = {
                    address_line_1: dados.numero + ' ' + dados.logradouro,
                    address_line_2: '',
                    city: cidade,
                    state: 'SP',
                    zip_code: dados.cep,
                    country: 'Brasil'
                }
                this.$geocoder.send(addressObj, response => {
                    this.latitude = response.results[0].geometry.location.lat
                    this.longitude = response.results[0].geometry.location.lng

                    this.center = {
                        lat: response.results[0].geometry.location.lat,
                        lng: response.results[0].geometry.location.lng
                    }
                })
            },
            geolocate: function () {
                navigator.geolocation.getCurrentPosition(position => {
                    this.center = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };
                });
            },
            salvar() {
                API.enviarRequisicao('post', '/api/sist-obras/obras', {
                    o01_numero: this.numero,
                    o01_objeto: this.objeto,
                    o01_descricao: this.descricao,
                    o01_contrato: this.contrato,
                    o01_dt_inicio: this.formataData(this.dtInicio),
                    o01_dt_prev_entrega: this.formataData(this.dtPrevista),
                    o01_dt_conclusao: this.formataData(this.dtConcl),
                    o01_cgm_fiscal: this.orgaoFisc,
                    o01_cgm_contratante: this.contratante,
                    o01_cgm_contratada: this.contratada,
                    o01_bairro: this.bairro,
                    o01_endereco: this.endereco,
                    o01_ender_numero: this.endNumero,
                    o01_refer_ender: this.referencia,
                    o01_latitude: this.latitude,
                    o01_longitude: this.longitude,
                    o01_valor: this.valorObra,
                    o01_art: this.numeroArt,
                    o01_cgm_resp_tecnico: this.respTecnico,
                    o01_area_id: this.tpAreaSel,
                    o01_tpobra_id: this.tpObraSel,
                    o01_tpexecucao_id: this.tpExecSel,
                    o01_situacao_id: this.tpSituSel,
                    o01_convenio_id: this.tpConvSel,
                    o01_cep: this.cep
                })
                    .then(response => {
                        this.$swal('Parabéns!', 'Dados salvos com sucesso.', 'success')
                            .then(
                                function () {
                                    history.go(0);
                                }
                            )
                    })
                    .catch(function (error) {
                        this.$swal('Atenção!', 'Erro ao cadastrar os dados.', 'error')
                    })
            },
        },
        mounted: function () {
            let thiss = this;
            API.enviarRequisicao('get', '/api/sist-obras/tipo-obras/obterCombo/dhtmlx/tpObras')
                .then(response => {
                    this.tpObras = response.data
                    comboTpObras = new dhtmlXCombo("combo_tpobra");
                    comboTpObras.load(this.tpObras, "json");
                    comboTpObras.enableFilteringMode(true);
                    comboTpObras.attachEvent("onChange", function (value) {
                        thiss.tpObraSel = value;
                    });
                }),

                API.enviarRequisicao('get', '/api/sist-obras/areas/obterCombo/dhtmlx/areas')
                    .then(response => {
                        this.areas = response.data
                        comboArea = new dhtmlXCombo("combo_area");
                        comboArea.load(this.areas, "json");
                        comboArea.enableFilteringMode(true);
                        comboArea.attachEvent("onChange", function (value) {
                            thiss.tpAreaSel = value;
                        });
                    }),

                API.enviarRequisicao('get', '/api/sist-obras/convenios/obterCombo/dhtmlx/convenios')
                    .then(response => {
                        this.convenios = response.data
                        comboConv = new dhtmlXCombo("combo_convenios");
                        comboConv.load(this.convenios, "json");
                        comboConv.enableFilteringMode(true);
                        comboConv.attachEvent("onChange", function (value) {
                            thiss.tpConvSel = value;
                        });
                    }),

                API.enviarRequisicao('get', '/api/sist-obras/execucoes/obterCombo/dhtmlx/tpExecucoes')
                    .then(response => {
                        this.tpExec = response.data
                        comboExec = new dhtmlXCombo("combo_execu");
                        comboExec.load(this.tpExec, "json");
                        comboExec.enableFilteringMode(true);
                        comboExec.attachEvent("onChange", function (value) {
                            thiss.tpExecSel = value;
                        });
                    }),

                API.enviarRequisicao('get', '/api/sist-obras/situacoes/obterCombo/dhtmlx/situacoes')
                    .then(response => {
                        this.situacoes = response.data
                        comboSituacoes = new dhtmlXCombo("combo_situacoes");
                        comboSituacoes.load(this.situacoes, "json");
                        comboSituacoes.enableFilteringMode(true);
                        comboSituacoes.attachEvent("onChange", function (value) {
                            thiss.tpSituSel = value;
                        });
                    })
        }

    }
</script>


<style scoped>

    .salvar {
        background-color: #18A689;
        color: #fff;
        font-size: 12px;
        text-decoration: none;
    }

    .unicCol {
        margin-left: 14px;
        width: 151px;
    }

    .label-autocomplete {
        position: relative;
        top: 55px;
        left: 20%;
        z-index: 999;
    }

    .mx-datepicker{
        width: 100%;
    }
</style>
